import { render } from "./Leaderboards.vue?vue&type=template&id=3070a334&scoped=true&bindings={}"
import script from "./Leaderboards.vue?vue&type=script&lang=ts"
export * from "./Leaderboards.vue?vue&type=script&lang=ts"

import "./Leaderboards.vue?vue&type=style&index=0&id=3070a334&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3070a334"

export default script